import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const financialRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.list.route,
      lazy: () => import("@pages/panelPages/financial/ruleList"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.financialRules", [], "index", "main");
        return {};
      },
    },
    permissions: ["super-admin", "admin", "local-admin"],
  },
  {
    route: {
      path: path.create.route,
      lazy: () => import("@/pages/panelPages/financial/ruleForm"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.defineFinancialRule",
            [{ title: "pageTitle.financialRules", url: path.list.link() }],
            "create",
          );
        return { mode: "create" };
      },
    },
    permissions: ["super-admin", "admin", "local-admin"],
  },
  {
    route: {
      path: path.edit.route,
      lazy: () => import("@/pages/panelPages/financial/updateRuleForm"),
      loader: ({ params, request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.defineFinancialRule",
            [{ title: "pageTitle.financialRules", url: path.list.link() }],
            "edit",
          );
        return { mode: "edit", id: params.id! };
      },
    },
    permissions: ["super-admin", "admin", "local-admin"],
  },
  {
    route: {
      path: path.view.route,
      lazy: () => import("@/pages/panelPages/financial/updateRuleForm"),
      loader: ({ params, request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.defineFinancialRule",
            [{ title: "pageTitle.financialRules", url: path.list.link() }],
            "view",
          );
        return { mode: "view", id: params.id! };
      },
    },
    permissions: ["super-admin", "admin", "local-admin"],
  },
  {
    route: {
      path: path.wallet.route,
      lazy: () => import("@pages/panelPages/financial/wallet"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.patientWallet", [], "index", "main");
        return {};
      },
    },
    permissions: ["super-admin", "admin", "staff", "local-admin"],
  },
  {
    route: {
      path: path.fiscalCreate.route,
      lazy: () =>
        import("@pages/panelPages/fiscalConfiguration/fiscalConfigurationPage"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.fiscalConfiguration",
            [{ title: "pageTitle.financialRules", url: path.list.link() }],
            "create",
          );
        return {};
      },
    },
    permissions: ["super-admin", "admin", "local-admin"],
  },
];
